<template>
  <b-col
    cols="8"
    class="px-0"
  >
    <b-input-group>
      <b-col
        v-for="(_, col) in legenditems"
        :key="`legend-label-${col}`"
        class="px-0"
      >
        <b-input-group>
          <b-input-group-prepend>
            <b-button
              v-if="legenditems.length > 1"
              size="sm"
              variant="outline-danger"
              @click="removeLegendItem(col)"
            >
              <font-awesome-icon icon="minus" />
            </b-button>
          </b-input-group-prepend>
          <!-- Bootstrap's input built in debounce only works on v-model  -->
          <b-input
            v-model="legenditems[col].label"
            :state="!v.legenditems.$each[col].label.$anyError && null"
          />
        </b-input-group>
      </b-col>
    </b-input-group>
  </b-col>
</template>

<script lang="ts">

import Vue, { PropType } from 'vue'
import Component from 'vue-class-component'

import {
  ComparisonGraphCategory,
  ComparisonGraphLegendItem,
} from '@/types'

const props = {
  categories: {
    type: Array as PropType<ComparisonGraphCategory[]>,
    required: true,
  },
  legenditems: {
    type: Array as PropType<ComparisonGraphLegendItem[]>,
    required: true,
  },
  v: {
    type: Object,
    required: true,
  },
}

@Component
export default class LegendLabels extends Vue.extend({ props }) {
  removeLegendItem (col: number) {
    this.legenditems.splice(col, 1)

    this.categories.forEach(category => {
      category.fields.splice(col, 1)
    })
    this.v.$touch()
  }
}

</script>
